module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "l-col-12@md"
  }, [_c('div', {
    staticClass: "l-row"
  }, [_c('form-group', {
    attrs: {
      "label": "Tipo de preço",
      "columns": 3,
      "required": true
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.input.type),
      expression: "input.type"
    }],
    staticClass: "form-select",
    attrs: {
      "disabled": _vm.block
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.input, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.onChangePriceType]
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Selecione")]), _vm._v(" "), _vm._l((_vm.priceTypeDI), function(priceType) {
    return _c('option', {
      domProps: {
        "value": priceType
      }
    }, [_vm._v("\n          " + _vm._s(priceType === 'source' ? _vm.$t('priceTypeModule.label') + _vm.$t(_vm.moduleLabel) : _vm.$t(priceType).label) + "\n        ")])
  })], 2)]), _vm._v(" "), (_vm.isTypePercent) ? _c('form-group', {
    attrs: {
      "label": "Percentual",
      "columns": 1,
      "required": true
    }
  }, [_c('div', {
    staticClass: "form-flex"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.percent),
      expression: "percent"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.percent)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.percent = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "form-addon"
  }, [_vm._v("%")])])]) : _vm._e(), _vm._v(" "), (_vm.isTypeFixedValue) ? _c('form-group', {
    attrs: {
      "label": "Valor fixo",
      "columns": 3,
      "required": true
    }
  }, [_c('money', _vm._b({
    staticClass: "form-input",
    model: {
      value: (_vm.fixedValue),
      callback: function($$v) {
        _vm.fixedValue = $$v
      },
      expression: "fixedValue"
    }
  }, 'money', _vm.money, false))], 1) : _vm._e(), _vm._v(" "), (_vm.isTypePercent) ? _c('form-group', {
    attrs: {
      "label": "Preço Atual Fonte",
      "columns": 2
    }
  }, [_c('div', {
    staticClass: "form-control has-iconRight"
  }, [_c('money', _vm._b({
    staticClass: "form-input",
    attrs: {
      "type": "text",
      "disabled": true
    },
    model: {
      value: (_vm.source.current),
      callback: function($$v) {
        _vm.$set(_vm.source, "current", $$v)
      },
      expression: "source.current"
    }
  }, 'money', _vm.money, false)), _vm._v(" "), _c('span', {
    staticClass: "form-iconRight"
  }, [_c('module-icon', {
    attrs: {
      "identifier": _vm.module.identifier
    }
  })], 1)], 1)]) : _vm._e(), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Preço antigo",
      "columns": 3,
      "required": true
    }
  }, [_c('money', _vm._b({
    staticClass: "form-input",
    attrs: {
      "disabled": _vm.disabled || _vm.block
    },
    model: {
      value: (_vm.previous),
      callback: function($$v) {
        _vm.previous = $$v
      },
      expression: "previous"
    }
  }, 'money', _vm.money, false))], 1), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Preço atual",
      "columns": 3,
      "required": true
    }
  }, [_c('money', _vm._b({
    staticClass: "form-input",
    attrs: {
      "disabled": _vm.disabled || _vm.block
    },
    model: {
      value: (_vm.current),
      callback: function($$v) {
        _vm.current = $$v
      },
      expression: "current"
    }
  }, 'money', _vm.money, false))], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fdadc83a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/ProductPriceUnique.vue
// module id = 3509
// module chunks = 0